import { api } from 'common';

import { CodeMirrorLanguageType } from '../../../../Code/types';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { type BlockConfigProps } from '../../types';

const GS_PATH_HELPER_TEXT = `Provide templatized text for a cloud storage path to the document file, e.g. {{ myBlock.data.fieldThatHasTheGsPath }}.`;

const PAYLOAD_HELPER_TEXT = `Provide the parent block name that contains the payload to be used to create the encounter summary.`;

function FormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.gsPath"
        label="GS Path"
        required
        helperText={GS_PATH_HELPER_TEXT}
      />
      <ParentBlockSelectField
        fieldName="config.payload"
        label="Payload"
        required
        helperText={PAYLOAD_HELPER_TEXT}
      />
    </>
  );
}

const documentationMarkdown = `
# Create Encounter Summary

## Description

The Create Encounter Summary block creates an encounter summary from a document file in Google Cloud Storage
for when the PVP note that was created by the LLM did not contain all of the information that the provider needed
and we need a human to review the note.

## Input Parameters

- **Google Storage Path**: The path to the document file in Google Cloud Storage.
- **Payload**: The payload required to create the encounter summary. The payload includes the following fields:
  - Orders
  - Lab Values
  - Medications
  - Document Text
  - Practitioner
  - Past Encounters
  - Evaluation Response
  - Past Hospital Visits
  - Patient Information
  - Past Telephone Visits
  - Past Outpatient Visits
  - Upcoming Appointments
  - Assessment And Plan Note
  - Practitioner Reference Code
  - Last Encounter With Practitioner
  - Last Encounter With Other Practitioner

## Output

The block creates an encounter summary in Notable and returns the encounter summary.

## Usage

This block is used to allow a human to review the PVP note that was created by the LLM. This is only used
in the case where the LLM did not include all of the information that the provider needed.
`;

export const createEncounterSummaryConfig: BlockConfigProps<api.FlowDefinition.CreateEncounterSummaryBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'createEncounterSummary',
    defaultConfig: {
      gsPath: '',
      payload: '',
    },
    configFields: {
      getLanguageFieldValues: (config) => {
        return {
          [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.gsPath],
        };
      },
      schema: api.FlowDefinition.CreateEncounterSummaryBlockConfigSchema,
      FormFields,
    },
    documentationMarkdown,
  };
